// extracted by mini-css-extract-plugin
export default {"spinner-container":"loading-spinner_spinner-container__NoQx2"};